import { useState, useEffect } from 'react'

const useIsLaptop = (): boolean => {
  const [isLaptop, setIsLaptop] = useState(false)

  useEffect(() => {
    const handleResize = (): void => {
      if (window.innerWidth > 1080) {
        setIsLaptop(true)
      } else {
        setIsLaptop(false)
      }
    }

    handleResize()

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return isLaptop
}

export default useIsLaptop
